

import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  // استخدام Redux store للحصول على بيانات المستخدم
  const user = useSelector((state) => state.auth.user);
  
  // fallback للبيانات من sessionStorage في حالة عدم وجود بيانات في Redux store
  const isAuthenticated = () => {
    if (user) return true;
    
        // التحقق من بيانات المدير
        // لا نعتبر المستخدم مسجل دخول إذا كان هناك فقط بيانات مؤقتة
        const tempData = sessionStorage.getItem("adminkhadamat_temp");
        if (tempData) {
          // هناك بيانات مؤقتة - المستخدم لم يقرر بعد (لا نعتبره مسجل دخول)
          return false;
        }
        
        const storedUser = sessionStorage.getItem("adminkhadamat");
        if (storedUser) {
          try {
            const parsed = JSON.parse(storedUser);
            if (!!parsed && parsed !== "null" && parsed.data && (parsed.data.token?.access_token || parsed.data.access_token)) {
              return true;
            }
          } catch {
            // تجاهل الخطأ والمتابعة للتحقق من أنواع أخرى
          }
        }
    
    // التحقق من بيانات المتجر والصيدليات
    const storedStore = sessionStorage.getItem("storekhadamat");
    if (storedStore) {
      try {
        const parsed = JSON.parse(storedStore);
        if (!!parsed && parsed !== "null" && (parsed.role === 'store' || parsed.role === 'pharmacy' || parsed.role === 'pharmacy_branch') && parsed.token) return true;
      } catch {
        // تجاهل الخطأ والمتابعة للتحقق من أنواع أخرى
      }
    }
    
    // التحقق من بيانات الفرع
    const storedBranch = sessionStorage.getItem("branchkhadamat");
    if (storedBranch) {
      try {
        const parsed = JSON.parse(storedBranch);
        if (!!parsed && parsed !== "null" && parsed.role === 'branch') return true;
      } catch {
        // تجاهل الخطأ
      }
    }
    
    // التحقق من بيانات الطبيب
    const storedDoctor = sessionStorage.getItem("doctorKhadamat");
    if (storedDoctor) {
      try {
        const parsed = JSON.parse(storedDoctor);
        if (!!parsed && parsed !== "null" && parsed.role === 'doctor' && parsed.token) return true;
      } catch {
        // تجاهل الخطأ
      }
    }
    
    // التحقق من بيانات العيادة
    const storedClinic = sessionStorage.getItem("clinicKhadamat");
    if (storedClinic) {
      try {
        const parsed = JSON.parse(storedClinic);
        if (!!parsed && parsed !== "null" && parsed.role === 'clinic' && parsed.token) return true;
      } catch {
        // تجاهل الخطأ
      }
    }
    
    return false;
  };

  // تحديد صفحة التوجيه بناءً على نوع المستخدم
  const getRedirectPath = () => {
    // التحقق من وجود أي بيانات في sessionStorage لتحديد نوع المستخدم
    const adminkhadamat = sessionStorage.getItem("adminkhadamat");
    const storekhadamat = sessionStorage.getItem("storekhadamat");
    const branchkhadamat = sessionStorage.getItem("branchkhadamat");
    const doctorKhadamat = sessionStorage.getItem("doctorKhadamat");
    const clinicKhadamat = sessionStorage.getItem("clinicKhadamat");
    
    // إذا كان هناك بيانات admin صحيحة ولم يكن مصرحاً بالدخول، وجهه لصفحة admin-login
    // نحافظ على السلوك السابق لكن نتحقق أن التوكن غير صالح قبل التوجيه
    if (adminkhadamat) {
      try {
        const parsed = JSON.parse(adminkhadamat);
        const hasToken = parsed && parsed !== "null" && parsed.data && (parsed.data.token?.access_token || parsed.data.access_token);
        if (!hasToken) {
          return "/admin-login";
        }
      } catch {
        return "/admin-login";
      }
    }
    
    // إذا كان هناك بيانات store أو branch أو doctor أو clinic، توجه إلى login
    if (storekhadamat || branchkhadamat || doctorKhadamat || clinicKhadamat) {
      return "/login";
    }
    
    // افتراضي للـ login إذا لم نجد أي بيانات صحيحة
    return "/login";
  };

  const authenticated = isAuthenticated();
  
  return authenticated ? children : <Navigate to={getRedirectPath()} replace />;
};

export default PrivateRoute;
